import React, { useState, useContext, useEffect } from 'react';
import '../../../assets/scss/filtersection.scss';
import { Button, Collapse, Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import yellowTick from '../../../assets/images/collection/yellow-tick_20px.svg';
import { ThemeContext } from '../../context/context';
import {
    useAccount,
} from 'wagmi'
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import defaultImage from '../../../assets/images/homeExplorer/placeholder.png'
import { handleImageError } from '../../../hooks/useHandleImg';
import DataService from '../../../lib/DataService';

const FilterActivitySection = () => {

    const [isOpenCollapse1, setIsOpenCollapse1] = useState(false);
    const toggleCollapse1 = () => {
        setIsOpenCollapse1(!isOpenCollapse1);
    }
    const [isOpenCollapse2, setIsOpenCollapse2] = useState(false);
    const toggleCollapse2 = () => {
        setIsOpenCollapse2(!isOpenCollapse2);
    }
    const [isOpenCollapse3, setIsOpenCollapse3] = useState(false);
    const toggleCollapse3 = () => {
        setIsOpenCollapse3(!isOpenCollapse3);
    }

    const { t } = useTranslation()
    const { getRequest, postRequest } = DataService()


    const { address } = useAccount()
    const { id } = useParams()

    const Status = [
        {
            id: 1,
            name: "All",
            sortStatusField: "",
        },
        {
            id: 2,
            name: "Active",
            sortStatusField: "1",
        },
        {
            id: 3,
            name: "Expiring",
            sortStatusField: "4",
        },
        {
            id: 3,
            name: "Inactive",
            sortStatusField: "3",
        },
    ]


    const Type = [
        {
            id: 1,
            name: "All",
            sortStatusField: "",
        },
        {
            id: 2,
            name: "Single Offers",
            sortStatusField: "make-offer",
        },
        {
            id: 3,
            name: "Collection Offers",
            sortStatusField: "make-collection-offer",
        },
        {
            id: 4,
            name: "Trait Collection Offers",
            sortStatusField: "traitoffer",
        },
    ]

    const { offermadestatus, setOfferMadeStatus, offermadetype, setOfferMadeType, offermadecollection, setOfferMadeCollection } = useContext(ThemeContext)

    const FilterOffermadeStatus = (data) => {
        let offermadestatus1 = Array.isArray(offermadestatus) ? [...offermadestatus] : [];

        if (data.sortStatusField === "") {
            setOfferMadeStatus([""]);
        }
        else if (data.sortStatusField === "4") {
            setOfferMadeStatus(["4"]);
        }
        else {
            if (data.sortStatusField === "1" || data.sortStatusField === "3") {
                const indexAll = offermadestatus1.indexOf("");
                if (indexAll > -1) {
                    offermadestatus1.splice(indexAll, 1);
                }
                const indexExpiring = offermadestatus1.indexOf("4");
                if (indexExpiring > -1) {
                    offermadestatus1.splice(indexExpiring, 1);
                }
            }

            const index = offermadestatus1.indexOf(data.sortStatusField);
            if (index > -1) {
                offermadestatus1.splice(index, 1);
            } else {
                offermadestatus1.push(data.sortStatusField);
            }

            if (offermadestatus1.length === 0) {
                offermadestatus1.push("");
            }

            setOfferMadeStatus([...offermadestatus1]);
        }
    }

    const FilterOffermadeType = (data) => {
        setOfferMadeType(data.sortStatusField)
        if (data.sortStatusField == "") {
            setOfferMadeType([""])
        }
        else {
            let a = offermadetype.includes(data.sortStatusField)
            if (a == true) {
                const index = offermadetype.indexOf(data.sortStatusField);
                if (index > -1) {
                    offermadetype.splice(index, 1);
                    const nerArr = [...offermadetype]
                    setOfferMadeType(nerArr);
                    if (nerArr.length == 0) {
                        setOfferMadeType([""]);
                    }
                }

            } else if (a == false) {
                const index = offermadetype.indexOf("");
                if (index > -1) {
                    offermadetype.splice(index, 1);
                }
                setOfferMadeType(
                    [...offermadetype, data.sortStatusField]
                );

            }
        }
    }



    useEffect(() => {
        GetFilterCollection()
    }, [address, id])


    const [collection, setCollection] = useState()

    const GetFilterCollection = async () => {
        const getcollection = await postRequest("user/offers_made_collections", { "address": id ? id : address })
        if (getcollection.status == true) {
            setCollection(getcollection.data)
        }
    }


    const handleCheckboxCollection = (item) => {
        let a = offermadecollection.includes(item.collectionName)

        if (a == true) {

            const index = offermadecollection.indexOf(item.collectionName);
            if (index > -1) {
                offermadecollection.splice(index, 1);
                const nerArr = [...offermadecollection]
                setOfferMadeCollection(nerArr);
            }

        } else if (a == false) {
            setOfferMadeCollection(
                [...offermadecollection, item.collectionName]
            );
        }
    }

    const handleOnKeyDown = async (e) => {
        if (e.key == 'Enter' || e.key == "") {
            const searchcollection = await postRequest("user/offers_made_collections", { "address": id ? id : address, "search": e.target.value })
            if (searchcollection.status == true) {
                setCollection(searchcollection.data)
            }
            else {
                setCollection("")
            }
        }
    }

    return (
        <>
            <div className='filtercard'>
                <div>
                    <Button className='filterTit' onClick={toggleCollapse1}>
                        <span>{t("Status")} </span>
                        <i className={`fas ${isOpenCollapse1 ? 'fa-angle-up' : 'fa-angle-down'}`} ></i>
                    </Button>
                    <Collapse isOpen={isOpenCollapse1}>
                        <div className='collapseCnt'>

                            {Status && Status.map((data, index) => (
                                <button className={offermadestatus.length > 0 ? offermadestatus.includes(data.sortStatusField) ? 'filterStatusbtn active' : 'filterStatusbtn' : 'filterStatusbtn'} onClick={() => FilterOffermadeStatus(data)}>{t(data.name)}</button>
                            ))}
                        </div>
                    </Collapse>
                </div>
                <div>
                    <Button className='filterTit' onClick={toggleCollapse2}>
                        <span>{t("Type")}</span>
                        <i className={`fas ${isOpenCollapse2 ? 'fa-angle-up' : 'fa-angle-down'}`} ></i>
                    </Button>
                    <Collapse isOpen={isOpenCollapse2}>
                        <div className='collapseCnt'>

                            {Type && Type.map((data, index) => (
                                <button className={offermadetype.length > 0 ? offermadetype.includes(data.sortStatusField) ? 'filterStatusbtn active' : 'filterStatusbtn' : 'filterStatusbtn'} onClick={() => FilterOffermadeType(data)}>{t(data.name)}</button>
                            ))}
                        </div>
                    </Collapse>
                </div>
                <div>
                    <Button className='filterTit' onClick={toggleCollapse3}>
                        <span>{t("Collection")} </span>
                        <i className={`fas ${isOpenCollapse3 ? 'fa-angle-up' : 'fa-angle-down'}`} ></i>
                    </Button>
                    <Collapse isOpen={isOpenCollapse3}>
                        <div className='collapseCnt'>
                            <div className="form-group formInputs">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText className='px-2'>
                                            <svg
                                                width="17"
                                                height="17"
                                                viewBox="0 0 17 17"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M15.875 14.6562C16.0312 14.8125 16.0312 15.0625 15.875 15.1875L15.1562 15.9062C15.0312 16.0625 14.7812 16.0625 14.625 15.9062L10.8438 12.125C10.7812 12.0312 10.75 11.9375 10.75 11.8438V11.4375C9.59375 12.4062 8.125 13 6.5 13C2.90625 13 0 10.0938 0 6.5C0 2.9375 2.90625 0 6.5 0C10.0625 0 13 2.9375 13 6.5C13 8.125 12.375 9.625 11.4062 10.75H11.8125C11.9062 10.75 12 10.8125 12.0938 10.875L15.875 14.6562ZM6.5 11.5C9.25 11.5 11.5 9.28125 11.5 6.5C11.5 3.75 9.25 1.5 6.5 1.5C3.71875 1.5 1.5 3.75 1.5 6.5C1.5 9.28125 3.71875 11.5 6.5 11.5Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder={t("Search collection")} name="searchInput" onKeyDown={handleOnKeyDown} />
                                </InputGroup>
                            </div>
                            <div class="scroller htcheckbox">
                                {collection && collection.length > 0 ?
                                    collection && collection.map((data, index) => (
                                        <div className={`${offermadecollection.length > 0 ? offermadecollection.includes(data.collectionName) ? 'h-verCollection' : "filterofferscard notrans mb-2" : "filterofferscard notrans mb-2"}`} onClick={() => handleCheckboxCollection(data)} onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                handleCheckboxCollection(data)
                                            }
                                        }}
                                            role="button" tabIndex={0} style={{ cursor: "pointer" }}>
                                            <div className='d-flex align-items-center' key={data.id}>
                                                {!data?.logoImage?.startsWith(process.env.S3_URL) && !data?.logoImage?.startsWith('ipfs') && data?.logoImage !== null ? <img src={data?.logoImage ? data?.logoImage : defaultImage} className="mr-2" height="36" width="36" style={{ objectFit: "cover", borderRadius: "10px" }} onError={handleImageError} /> : <img src={defaultImage} className="mr-2" height="36" width="36" style={{ objectFit: "cover", borderRadius: "10px" }} />}
                                                <div>
                                                    <div className='fs-12 fw-600 dark-text'>
                                                        {data.collectionName}
                                                        <img src={data.verification == "Verified" ? yellowTick : ""} className="ml-1" />
                                                    </div>
                                                    <div>Listed: {data.listedItems == "" ? 0 : data.listedItems.toString()}/{data.totalItems.toString()}</div>
                                                </div>
                                                <div className='text-right ml-auto'>
                                                    <div><span className="whiteTxt">Floor:</span> {parseFloat(data.floorPrice)} {data.chain == "ethereum" ? "ETH" : data.chain == "binance" ? "BNB" : data.chain == "polygon" ? "MATIC" : ""}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    :

                                    <p style={{ justifyContent: "center", display: "flex" }}>{t("No Data Found")}</p>

                                }
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>

        </>
    );
}

export default FilterActivitySection;